import { divide } from 'lodash-es'
import React, { useState, useEffect } from 'react'
import { Button, Modal, Table } from 'react-bootstrap'
import { Auth } from 'aws-amplify'
import ReplaceVideoPointsService from '../../Services/Mutations/ReplaceContentPoints'
import ModifyContentPoints from '../../Services/Mutations/ModifyContentPoints'
import DeleteContentInSingleLanguage from '../../Services/Mutations/DeleteContentInSingleLanguage'
import DeleteContent from '../../Services/Mutations/DeleteContent'
class DeleteContentAction extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      contentSelectedLang: null,
      deleteModalVisible: false,
      selectedContentId: '',
      selectedContentLanguages: [],
      capturePostModal: false,
      selectedItem: null,
    }
  }
  handleDelete = async () => {
    const item = this.state.selectedContentId
    this.setState({ deleteModalVisible: false })

    if (
      this.state.selectedContentId.contentLanguages.length == 1 ||
      this.state.selectedContentId.contentLanguages.length ==
        this.state.selectedContentLanguages.length
    ) {
      const input = { contentID: item.PK }
      console.log(input, 'input')
      const data = await DeleteContent(input)
      console.log(data, 'delete contenttttt')

      if (data.statusCode == 'A185') {
        this.props.displayToast('success', 'Content Deleted Successfully')
        this.props.refreshContents(item.PK, false)
        // toast.success('Content Deleted Successfully', this.toastStyle)
      } else {
        this.props.displayToast('error', 'Failed to delete content')
        // toast.error('Failed to delete content', this.toastStyle)
      }
    } else {
      const input = {
        contentID: item.PK,
        language: this.state.selectedContentLanguages[0],
      }
      const data = await DeleteContentInSingleLanguage(input)

      if (data.statusCode == 'A296') {
        this.props.displayToast('success', 'Content Deleted Successfully')
        this.props.refreshContents(item.PK, true, this.state.selectedContentLanguages)
      } else {
        this.props.displayToast('error', 'Failed to delete content')
      }
    }
  }
  openDeleteModal = () => {
    this.setState({ selectedContentId: this.props.item, deleteModalVisible: true })
  }
  closeDeleteModal = () => {
    this.setState({ selectedContentId: '', deleteModalVisible: false })
  }
  handleLanguage = (selectedlang) => {
    const { selectedContentLanguages } = this.state
    const selectedLangIndex = selectedContentLanguages.findIndex((lang) => lang == selectedlang)

    if (selectedContentLanguages.includes(selectedlang)) {
      selectedContentLanguages.splice(selectedLangIndex, 1)
    } else {
      selectedContentLanguages.push(selectedlang)
    }
    this.setState({ selectedContentLanguages: selectedContentLanguages })
  }
  renderDeleteConfirmationModal = () => {
    const { deleteModalVisible, selectedContentLanguages } = this.state
    return (
      <Modal show={deleteModalVisible} onHide={() => this.closeDeleteModal()}>
        <Modal.Body>
          <div>
            {this.state.selectedContentId.contentLanguages &&
              this.state.selectedContentId.contentLanguages.length > 1 &&
              this.state.selectedContentId.contentLanguages.map((language) => {
                let lang
                if (language == 'En') {
                  lang = 'English'
                } else {
                  lang = 'Telugu'
                }
                return (
                  <div class='row'>
                    <div class='col-md-1'>
                      <input
                        type='checkbox'
                        onClick={() => this.handleLanguage(lang)}
                        checked={selectedContentLanguages.includes(lang)}
                      ></input>
                    </div>
                    <div class='col-md-8'>
                      <text for='text'> {lang} </text>
                    </div>
                  </div>
                )
              })}
          </div>
          <div className='row'>
            <text>Are you sure you want to delete this content?</text>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => this.closeDeleteModal()}>Cancel</Button>
          {this.state.selectedContentId.contentLanguages &&
          this.state.selectedContentId.contentLanguages.length > 1 ? (
            this.state.selectedContentLanguages.length > 0 ? (
              <Button onClick={() => this.handleDelete()}>Ok</Button>
            ) : (
              <Button disabled onClick={() => this.handleDelete()}>
                Ok
              </Button>
            )
          ) : (
            <Button onClick={() => this.handleDelete()}>Ok</Button>
          )}
        </Modal.Footer>
      </Modal>
    )
  }
  render() {
    const {
      pointsModalVisible,
      modifyType,
      otherPoints,
      modifyPoints,
      mask,
      replacePoints,
    } = this.state
    return (
      <div>
        {this.props.rank ? (
          <div
            onClick={() => {
              this.openDeleteModal(true)
            }}
          >
            <label>Delete Content</label>
          </div>
        ) : (
          <div
            class='col-md-2'
            onClick={() => {
              this.openDeleteModal(true)
            }}
          >
            <i class='fas fa-star' />
          </div>
        )}

        {this.renderDeleteConfirmationModal()}
      </div>
    )
  }
}

export default DeleteContentAction
